module.exports = __webpack_public_path__ + "img/easytick.a562315e.png";